export const LOCATION_USER_ROLES = {
  OWNER: 'owner',
  ARTIST: 'artist',
};

export const LOCATION_USER_ROLE_OPTIONS = [
  {
    value: LOCATION_USER_ROLES.OWNER,
    label: 'Owner',
    tooltipKey: 'usersTab.ownerRoleTooltip',
  },
  {
    value: LOCATION_USER_ROLES.ARTIST,
    label: 'Artist',
    tooltipKey: 'usersTab.artistRoleTooltip',
  },
];

export const normalizeLocationUserRole = (role) => {
  if (role === 'Owner') return LOCATION_USER_ROLES.OWNER;
  if (role === 'Artist') return LOCATION_USER_ROLES.ARTIST;

  return role;
};
